import {
	Command,
	EditorState,
	Transaction
} from "prosemirror-state";
import { mentionInputSchema } from "../schema";

export const insertBreak: Command = (
	state: EditorState,
	dispatch: ((tr: Transaction) => void) | undefined
): boolean => {
	const {
		hard_break
	} = mentionInputSchema.nodes;

	if (dispatch) {
		const tr: Transaction = state.tr;

		tr.replaceSelectionWith(
			hard_break.create()
		);

		dispatch(tr.scrollIntoView());
	}

	return true;
};